import type { RequiredLocalStateOptions } from "@/components/ec/endlaTypes";
import type { LocalStatePlugin } from "@/components/ec/engine/plugins/LocalStatePlugin";
import type { ModelName } from "@/endlaFunctions/customTypings/ecTypes";
import type { EndlaAtom } from "@/persistentAtoms/EndlaAtomFamilies/endlaAtomFamilyTypes";

export type ModelBasedPluginState = {
  state: {
    modelAtom: EndlaAtom<ModelName>;
    isModelEditableAtom: EndlaAtom<boolean>;
  };
};

export function modelBasedAtomsPlugin<
  TOptions extends RequiredLocalStateOptions & {
    isModelEditable?: boolean;
  },
>(): LocalStatePlugin<ModelBasedPluginState, TOptions, Record<string, never>> {
  return {
    getPluggedInOptions: () => ({}),
    getPluggedInLocalState: (options, _state, $) => ({
      state: {
        modelAtom: $.atom("modelAtom", options.model ?? ""),
        isModelEditableAtom: $.atom("isModelEditableAtom", options.isModelEditable ?? true),
      },
    }),
  };
}
